var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallRejectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0005 8.05425L1.9275 13.1275C1.789 13.2658 1.61492 13.3367 1.40525 13.34C1.19575 13.3432 1.0185 13.2723 0.8735 13.1275C0.728667 12.9825 0.65625 12.8068 0.65625 12.6005C0.65625 12.3942 0.728667 12.2185 0.8735 12.0735L5.94675 7.0005L0.8735 1.9275C0.735167 1.789 0.664333 1.61492 0.661 1.40525C0.657833 1.19575 0.728667 1.0185 0.8735 0.8735C1.0185 0.728667 1.19417 0.65625 1.4005 0.65625C1.60683 0.65625 1.7825 0.728667 1.9275 0.8735L7.0005 5.94675L12.0735 0.8735C12.212 0.735167 12.3861 0.664333 12.5958 0.661C12.8053 0.657833 12.9825 0.728667 13.1275 0.8735C13.2723 1.0185 13.3448 1.19417 13.3448 1.4005C13.3448 1.60683 13.2723 1.7825 13.1275 1.9275L8.05425 7.0005L13.1275 12.0735C13.2658 12.212 13.3367 12.3861 13.34 12.5958C13.3432 12.8053 13.2723 12.9825 13.1275 13.1275C12.9825 13.2723 12.8068 13.3448 12.6005 13.3448C12.3942 13.3448 12.2185 13.2723 12.0735 13.1275L7.0005 8.05425Z",
    fill: "#F44649"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallRejectedIcon);
export default __webpack_public_path__ + "static/media/callRejectedIcon.fc84614b78bd19ffa1b096b8add8a0c9.svg";
export { ForwardRef as ReactComponent };